import React from 'react';
import Button from './Button';
import TestimonialCard from './TestimonialCard';
const CTASection = () => {
  return <div className="w-full bg-amber-100 text-gray-800 py-16 px-4" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700 text-center" data-id="element-13">
          15 minut, które uratowały moje życie
        </h2>
        <p className="text-lg mb-6" data-id="element-14">
          Dziś, pół roku później, nadal robię swoje 15 minut dziennie. To mój
          święty czas. Czas, kiedy przypominam sobie, kim jestem.
        </p>
        <p className="text-lg mb-6" data-id="element-15">
          Nie zmieniłam całego życia. Mama nadal potrzebuje opieki. Dzieci nadal
          mają swoje problemy. Ale ja już nie ginę w tym wszystkim.
        </p>
        <p className="text-lg mb-6" data-id="element-16">Mam swój plan. Mały, skromny, ale MÓJ.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8" data-id="element-17">
          <div className="bg-white p-6 rounded-lg shadow-md transform hover:scale-105 transition-transform" data-id="element-18">
            <p className="text-lg" data-id="element-19">
              <span className="text-orange-500 font-bold" data-id="element-20">✓</span> Zapisałam się
              na kurs tańca. Raz w tygodniu, wieczorem, gdy mama śpi. To tylko
              godzina, ale to moja godzina.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform hover:scale-105 transition-transform" data-id="element-21">
            <p className="text-lg" data-id="element-22">
              <span className="text-orange-500 font-bold" data-id="element-23">✓</span> Zaczęłam
              pisać. Może kiedyś będzie z tego książka, może nie. Ale piszę. Dla
              siebie.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md transform hover:scale-105 transition-transform" data-id="element-24">
            <p className="text-lg" data-id="element-25">
              <span className="text-orange-500 font-bold" data-id="element-26">✓</span> Założyłam
              mały ogródek na balkonie. Nic wielkiego, kilka doniczek z ziołami.
              Ale gdy je podlewam, czuję się jak ja.
            </p>
          </div>
        </div>
        <p className="text-lg mb-6" data-id="element-27">
          I wiesz co? Wszyscy wokół mają się lepiej. Mama jest spokojniejsza, bo
          ja nie jestem ciągłym kłębkiem nerwów. Dzieci przestały się o mnie
          martwić.
        </p>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-amber-400" data-id="element-28">
          <p className="text-lg italic" data-id="element-29">
            "Dobrze cię widzieć, mamo" – powiedział syn przed wyjazdem. To były
            najpiękniejsze słowa, jakie słyszałam od lat.
          </p>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold my-8 text-gray-700" data-id="element-30">
          Czy inne kobiety też to czują?
        </h2>
        <p className="text-lg mb-6" data-id="element-31">
          Po trzech miesiącach zaczęłam pisać na forum, gdzie znalazłam tamten
          post Magdy. Chciałam podzielić się swoimi doświadczeniami.
        </p>
        <p className="text-lg mb-6" data-id="element-32">
          Odpowiedzi, które dostałam, pokazały mi, że nie jestem sama:
        </p>
        <div className="my-8 space-y-6" data-id="element-33">
          <TestimonialCard name="Joanna" age={42} text="Kasia, dokładnie to samo! Po miesiącu z e-bookiem córka powiedziała mi, że wyglądam 'normalnie'. Wcześniej nie wiedziałam, że wyglądałam nienormalnie..." data-id="element-34" />
          <TestimonialCard name="Agnieszka" age={47} text="3 tygodnie i już nie czuję się jak duch. Mąż zapytał, czy zrobiłam sobie fryzurę, ale ja tylko zaczęłam być sobą." data-id="element-35" />
          <TestimonialCard name="Teresa" age={51} text="Moja mama (89 lat) powiedziała: 'Córko, dawno cię nie widziałam tak uśmiechniętą'. A ja wcześniej nie wiedziałam, że nie uśmiecham się..." data-id="element-36" />
          <TestimonialCard name="Dorota" age={49} text="Wreszcie pamiętam, jak się nazywam. I nie mówię o imieniu." data-id="element-37" />
        </div>
        <p className="text-lg mb-6" data-id="element-38">
          Okazało się, że tysiące kobiet przeszło przez to samo. I że te 15
          minut dziennie naprawdę zmieniają wszystko.
        </p>
        <div className="bg-white p-8 rounded-lg shadow-lg my-12 border-2 border-amber-300" data-id="element-39">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-40">
            Może to też twoja historia?
          </h3>
          <p className="text-lg mb-4" data-id="element-41">
            Jeśli czytając to czujesz ściskanie w gardle...
          </p>
          <p className="text-lg mb-4" data-id="element-42">
            Jeśli nie pamiętasz, kiedy ostatnio pomyślałaś o sobie bez poczucia
            winy...
          </p>
          <p className="text-lg mb-4" data-id="element-43">
            Jeśli wszyscy dookoła mają plany, marzenia, cele – a ty masz tylko
            obowiązki...
          </p>
          <p className="text-lg mb-6" data-id="element-44">
            Jeśli czujesz się jak duch we własnym życiu...
          </p>
          <p className="text-xl font-bold mb-6 text-center" data-id="element-45">
            To może ten e-book jest też dla ciebie.
          </p>
          <p className="text-lg mb-6" data-id="element-46">
            "Nie zapomnij o sobie" to nie jest kolejny poradnik, który doda ci
            obowiązków. To przewodnik, jak nie zginąć we własnym życiu. Jak
            odnaleźć siebie w 15 minut dziennie.
          </p>
          <h4 className="text-xl font-bold mb-4" data-id="element-47">
            Co dokładnie znajdziesz w środku?
          </h4>
          <p className="text-lg mb-4" data-id="element-48">
            12 rozdziałów, z których każdy to inna historia, inny temat, inny
            fragment twojej codzienności. Ale wszystkie łączy jedno: codzienne
            łagodne ratowanie siebie.
          </p>
          <p className="text-lg mb-4" data-id="element-49">
            Każdy rozdział składa się z trzech prostych rzeczy:
          </p>
          <ul className="mb-6 space-y-3" data-id="element-50">
            <li className="flex items-start" data-id="element-51">
              <span className="text-amber-500 mr-2 font-bold" data-id="element-52">•</span>
              <span className="text-lg" data-id="element-53">
                <span className="font-semibold" data-id="element-54">Słów wsparcia</span> – jakby
                mówiła do ciebie bliska przyjaciółka, która naprawdę rozumie
              </span>
            </li>
            <li className="flex items-start" data-id="element-55">
              <span className="text-amber-500 mr-2 font-bold" data-id="element-56">•</span>
              <span className="text-lg" data-id="element-57">
                <span className="font-semibold" data-id="element-58">Ćwiczenia pisemnego</span> –
                które pozwoli ci zatrzymać się i zajrzeć w głąb siebie bez
                presji
              </span>
            </li>
            <li className="flex items-start" data-id="element-59">
              <span className="text-amber-500 mr-2 font-bold" data-id="element-60">•</span>
              <span className="text-lg" data-id="element-61">
                <span className="font-semibold" data-id="element-62">Mikropraktyki</span> – małego,
                łagodnego rytuału na 3-15 minut
              </span>
            </li>
          </ul>
          <p className="text-lg mb-6" data-id="element-63">
            Nie potrzebujesz ciszy, świeczek, maty do jogi, dzieci u babci i
            partnera poza domem.
          </p>
          <p className="text-xl mb-6 font-bold text-center" data-id="element-64">
            Potrzebujesz jednej rzeczy: decyzji, że też jesteś ważna.
          </p>
          <div className="mt-10 bg-amber-50 p-6 rounded-lg" data-id="element-65">
            <h4 className="text-2xl font-bold mb-4 text-center" data-id="element-66">
              Tylko 27,99 zł za odzyskanie siebie
            </h4>
            <p className="text-lg mb-6" data-id="element-67">
              Wiem, że może się zastanawiasz, czy warto.
            </p>
            <p className="text-lg mb-6" data-id="element-68">
              27,99 zł to koszt dwóch kaw w kawiarni. Kawy, na które pewnie nie
              masz czasu, bo jesteś zajęta opieką nad wszystkimi.
            </p>
            <p className="text-lg mb-6" data-id="element-69">
              Ale to może być cena za odzyskanie siebie.
            </p>
            <p className="text-lg mb-6" data-id="element-70">
              Za przypomnienie sobie, kim jesteś poza rolami, które pełnisz.
            </p>
            <p className="text-lg mb-6" data-id="element-71">
              Za 15 minut dziennie, które będą należały tylko do ciebie.
            </p>
            <div className="mt-8 flex justify-center" data-id="element-72">
              <Button data-id="element-73" />
            </div>
            <p className="text-sm text-gray-600 text-center mt-4" data-id="element-74">
              Za 27,99 zł możesz zacząć odzyskiwać siebie już dziś. Zaledwie 15
              minut dziennie dzieli cię od bycia sobą.
            </p>
          </div>
        </div>
        <div className="mt-8" data-id="element-75">
          <p className="text-lg italic" data-id="element-76">
            P.S. Pamiętaj – nie musisz być silna cały czas. Musisz tylko być. To
            wystarczy.
          </p>
          <p className="text-lg italic mt-4" data-id="element-77">
            P.P.S. Ten e-book napisała kobieta, która sama przeszła przez to, co
            ty. Sama zapomniała, kim jest. Sama odnalazła drogę powrotną. Nie
            oferuje cudów. Obiecuje tylko, że pokaże ci, jak nie zniknąć. Jak
            zachować siebie, nawet gdy cały świat chce, żebyś była kimś innym.
          </p>
        </div>
      </div>
    </div>;
};
export default CTASection;